import { DeliveryTypesAvailable, Restaurant } from '@app/types';
import { useMemo } from 'react';

type Params = {
  restaurant: Restaurant;
  totalItemsPrice: number;
  selectedDeliveryType: string;
  isAnInternalMenu: boolean;
  isOrderedOnRestaurant: boolean;
  nowDate: Date;
};

export function useDeliveryTax(params: Params) {
  const {
    restaurant,
    isAnInternalMenu,
    isOrderedOnRestaurant,
    totalItemsPrice,
    selectedDeliveryType,
    nowDate,
  } = params;

  const value = useMemo(() => {
    if (isNotEligibleToTax()) return null;

    if (isToTaxByWeekDay()) return todayTax();
    return restaurant.taxaEntrega ?? 0;

    function isNotEligibleToTax() {
      return Boolean(
        isAnInternalMenu ||
          isOrderedOnRestaurant ||
          selectedDeliveryType === DeliveryTypesAvailable.LocalPickup ||
          isOnlyOnOrder() ||
          isOutOfMinValueToApplyTax()
      );
    }

    function isOnlyOnOrder() {
      return restaurant.Configuracoes?.apenasEncomenda === true;
    }

    function isOutOfMinValueToApplyTax() {
      const config = restaurant.Configuracoes;
      return config?.valorDeCompraComTaxaEntrega && totalItemsPrice > config.valorDeCompraComTaxaEntrega;
    }

    function isToTaxByWeekDay() {
      return restaurant.Configuracoes?.usarTaxaEntregaPorDiasDaSemana === true;
    }

    function todayTax() {
      const taxes = Object.values(restaurant.Configuracoes?.taxaEntregaPorDiasDaSemana ?? {});
      const dayWeek = nowDate.getDay();
      return taxes[dayWeek] ?? 0;
    }
  }, [restaurant, selectedDeliveryType, totalItemsPrice, isAnInternalMenu, isOrderedOnRestaurant, nowDate]);

  return value;
}
